import { useRpc } from "../core/useRpc.js";
import { extendPromise } from "../../utils/promise.js";
import { useRpcCall } from "../core/useRpcCall.js";
export function useIDP(params = {}, key) {
  const useRpcPromise = useRpc(
    "getExternalIdpRedirect",
    key ?? "useIDP",
    params
  );
  const {
    data,
    fetch,
    fetching,
    error,
    refresh,
    status
  } = useRpcPromise;
  const handleIDPLoginCallback = useRpcCall("handleIDPLoginCallback");
  return extendPromise(useRpcPromise.then(() => ({})), {
    data,
    fetch,
    fetching,
    error,
    refresh,
    status,
    // TODO: [Next Major Release] Deprecate the property here and remove it with the next major release
    handleIDPLoginCallback
  });
}
